import * as Yup from "yup";

export const dataModel = {
  varietyCode: "",
  entryPoint: "",
  outPoints: "",
  // varietyItemCodeProcessed: "",
  // batch: "",
  // borrellID: "",
  // harvestYear: 0,
};

export const validationDataModel = () => {
  return Yup.object().shape({
    varietyCode: Yup.string().required("forms.validations.required"),
    entryPoint: Yup.string().required("forms.validations.required"),
    // varietyItemCodeProcessed: Yup.string().required(
    //   "forms.validations.required",
    // ),
    outPoints: Yup.array().required("forms.validations.required"),
    // borrellID: Yup.number().required("forms.validations.required"),
    // harvestYear: Yup.string().required("forms.validations.required"),
  });
};

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
